import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { CheckoutInfo, PackageState } from './package.types'
import { PersistConfig } from 'redux-persist'
import { storage } from '../core'

const initialState: PackageState = {
  packages: {},
  checkoutInfo: {},
}
export const PACKAGE_STATE_NAME = 'package'

export const packageSlice = createSlice({
  name: PACKAGE_STATE_NAME,
  initialState,
  reducers: {
    setPackage: (state, action: PayloadAction<PackageState['packages']>) => {
      state.packages = {
        ...state.packages,
        ...action.payload,
      }
    },
    setCheckoutInfo: (
      state,
      action: PayloadAction<{ sessionId: string; checkoutInfo: CheckoutInfo }>,
    ) => {
      const { sessionId, checkoutInfo } = action.payload
      if (!sessionId) return
      state.checkoutInfo[sessionId] = {
        ...state.checkoutInfo[sessionId],
        ...checkoutInfo,
      }
    },
    clearCheckoutInfo: (state, action: PayloadAction<string>) => {
      delete state.checkoutInfo[action.payload]
    },
  },
})

export const packageSliceConfig: PersistConfig<PackageState> = {
  storage,
  key: PACKAGE_STATE_NAME,
  whitelist: ['checkoutInfo'],
}

export const { setPackage, setCheckoutInfo, clearCheckoutInfo } = packageSlice.actions

export default packageSlice.reducer
